import { jsx as _jsx } from "react/jsx-runtime";
var Fire = function Fire(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    fill: "none",
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.495 9.517c-2.032 2.199-1.989 5.685.129 7.844A5.385 5.385 0 0 0 11.496 19h.005a5.41 5.41 0 0 0 3.885-1.64c2.156-2.198 2.152-5.773-.009-7.968l-2.986-3.051c-.302 2.482-1.233 4.66-2.891 4.66-.508 0-1.336-.226-2.005-1.485Zm4.006 11.485h-.007a7.363 7.363 0 0 1-5.299-2.242c-2.914-2.97-2.918-7.803-.009-10.768l.983-.994a1 1 0 0 1 1.679.454c.23.889.504 1.326.655 1.492.355-.374.997-1.885.997-4.442 0-.147 0-.286-.008-.425a1.01 1.01 0 0 1 1.722-.773l4.59 4.689c2.92 2.964 2.925 7.797.01 10.768A7.392 7.392 0 0 1 11.501 21Z",
      fill: color
    })
  });
};
export default Fire;